import axios from "../../utils/axiosConfig";
import {
  addPolicyDTO,
  putPolicyDTO,
  deletePolicyDTO,
} from "../../dtos/policy";
import decryptResponse from "../../utils/decrypt_new";

// get policy
const getPolicy = async (id: number) => {
  try{
    const { data } = await axios.get("/api/pharmacy_policy/get", {
      params: { pharmacy_id: id },  // Correctly passing the parameter in 'params'
    });
    if (data?.data?.encryptedData && data?.data?.iv) {
      return decryptResponse(data?.data?.encryptedData, data?.data.iv)
    } else {
      return data?.data;
    }
  
  } catch (error) {
    console.error("Error getting policy:", error);
    throw new Error("Failed to get policy");
  }
  };


// add policy
const addPolicy = async (policy: addPolicyDTO) => {
  try {
    const { data } = await axios.post("/api/pharmacy_policy/add", policy);

    if (data?.data?.encryptedData && data?.data?.iv) {
      return decryptResponse(data?.data?.encryptedData, data?.data.iv);
    } else {
     return data;
    }
  } catch (error) {
    console.error("Error adding staff duty:", error);
    throw new Error("Failed to add staff duty");
  }
};


//update policy
const putPolicy = async (policy: putPolicyDTO) => {
  try {
    const { data } = await axios.put("/api/pharmacy_policy/edit", policy);
    if (data?.data?.encryptedData && data?.data?.iv) {
        return decryptResponse(data?.data?.encryptedData, data?.data.iv);
    } else {
     return data;
    }
  } catch (error) {
    console.error("Error updating staff duty:", error);
    throw new Error("Failed to update staff duty");
  }
};


//delete policy
const deletePolicy = async (policy: deletePolicyDTO) => {
  try{
  const { data } = await axios.delete(`/api/pharmacy_policy/delete`, { params: {policy_id: policy?.policy_id, pharmacy_id: policy?.pharmacy_id} });
  if (data?.data?.encryptedData && data?.data?.iv) {
    return decryptResponse(data?.data?.encryptedData, data?.data.iv);
  } else {
   return data;
  }
} catch (error) {
  console.error("Error adding staff duty:", error);
  throw new Error("Failed to add staff duty");
}
};

const policyService = {
  getPolicy,
  addPolicy,
  deletePolicy,
  putPolicy,
};

export default policyService;
